import { createRouter, createWebHashHistory } from "vue-router";

import pbxCloudRouter from "@/modules/pbxCloud/router";
import videoConferenciaRouter from "@/modules/videoConferencia/router";
import crmRouter from "@/modules/crm/router";
import fxCrmRouter from "@/modules/fxCrm/router";
import reportesRouter from "@/modules/reportes/router";
import reportesV2Router from "@/modules/reportesV2/router";
import reportesJoinRouter from "@/modules/reportesJoin/router";
import reportesCrmRouter from "@/modules/reportesCrm/router"
import reportesFxCrmRouter from "@/modules/reportesFxCrm/router"
import authRouter from "@/modules/auth/router"
import adminRouter from "@/modules/admin/router";
import adminJoinRouter from "@/modules/adminJoin/router";
import sipmovilRouter from "@/modules/SipMovil/router";
import fexeriaRouter, { ensureAccess as fexeriaAccess } from "@/modules/fexeria/router";

import isAuthenticatedGuard, { isGuestGuard } from "./auth-guard";
import { hasAnyPermissionGuard } from "./permission-guard";
import { MODULE_ACCESS, ROUTE_ACCESS, meetsAccess } from "./access-map";
const routes = [
  {
    path: "/",
    beforeEnter: [ isAuthenticatedGuard ],
    redirect: "/pbxCloud",
  },
  {
    path:"/auth",
    beforeEnter: [ isGuestGuard ],
    ...authRouter,
  },
  {
    path: "/pbxCloud",
    meta: { title: 'FEXCOM' },
    beforeEnter:[ isAuthenticatedGuard ] ,
    ...pbxCloudRouter,
  },
  {
    path: "/webMeetings",
    // Legacy sin entrada en menú: solo requiere sesión autenticada.
    beforeEnter: [ isAuthenticatedGuard ],
    ...videoConferenciaRouter,
  },
  {
    path: "/crm",
    meta: { title: 'FEXCOM CRM' },
    // Legacy (reemplazado por fxCrm): solo requiere sesión autenticada.
    beforeEnter: [ isAuthenticatedGuard ],
    ...crmRouter
  },
  {
    path: "/fxCrm",
    meta: { title: 'FEXCOM CRM' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.fxCrm),
    ],
    ...fxCrmRouter
  },
  {
    path: '/reportes',
    meta: { title: 'FEXCOM REPORTES' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.reportes),
    ],
    ...reportesRouter
  },
  {
    path: '/reportesV2',
    meta: { title: 'FEXCOM REPORTES' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.reportesV2),
    ],
    ...reportesV2Router
  },
  {
    path: '/reportesJoin',
    meta: { title: 'FEXCOM JOIN' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.reportesJoin),
    ],
    ...reportesJoinRouter
  },
  {
    path:"/admin",
    meta: { title: 'FEXCOM ADMIN' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.admin),
    ],
    ...adminRouter
  },
  {
    path:"/admin-join",
    meta: { title: 'FEXCOM ADMIN' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.adminJoin),
    ],
    ...adminJoinRouter
  },
  {
    path: '/reportesCrm',
    meta: { title: 'FEXCOM REPORTES' },
    // Legacy (reemplazado por reportes fxCrm): solo requiere sesión autenticada.
    beforeEnter: [ isAuthenticatedGuard ],
    ...reportesCrmRouter
  },
  {
    path: '/reportesFxCrm',
    meta: { title: 'FEXCOMCRM REPORTES' },
    // Legacy/router vacío: solo requiere sesión autenticada.
    beforeEnter: [ isAuthenticatedGuard ],
    ...reportesFxCrmRouter
  },
  {
    path: '/SipMovil',
    meta: { title: 'FEXCOM' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.SipMovil),
    ],
    ...sipmovilRouter
  },
  {
    path: '/fexeria',
    meta: { title: 'FEXERÍA' },
    beforeEnter: [
      isAuthenticatedGuard,
      hasAnyPermissionGuard(MODULE_ACCESS.fexeria),
      fexeriaAccess,
    ],
    ...fexeriaRouter
  },
  {
    path: '/system-updates',
    name: 'system-updates',
    meta: { title: 'Novedades del Sistema' },
    beforeEnter: [isAuthenticatedGuard],
    component: () =>
      import(
        /* webpackChunkName: "system-updates" */ '@/modules/shared/pages/SystemUpdates.vue'
      ),
  },
  {
    path: '/system-updates/:id',
    name: 'system-update-detail',
    meta: { title: 'Novedades del Sistema' },
    beforeEnter: [isAuthenticatedGuard],
    component: () =>
      import(
        /* webpackChunkName: "system-updates" */ '@/modules/shared/pages/SystemUpdates.vue'
      ),
    props: true,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to) => {
  // Control de acceso a sub-rutas con rol más fino que el del módulo (ver access-map.js).
  const access = ROUTE_ACCESS[to.name]
  if (access && !meetsAccess(access)) {
    console.log(' --- USUARIO SIN PERMISOS PARA ESTA SUB-RUTA --- ')
    return { name: access.redirect || 'pbxCloud' }
  }
  document.title = to.meta?.title ?? 'FEXCOM Cloud'
})
export default router;
